<template>
  <div>
    <div class="d-flex justify-center">
      <v-btn
        x-large=""
        rounded=""
        @click.native="selectFile"
        color="primary"
        v-if="!uploading"
      >
        UPLOAD NEW AVATAR
        <v-icon right aria-hidden="true">
          mdi-cloud-upload
        </v-icon>
      </v-btn>
    </div>
    <div class="d-flex justify-center align-center flex-column">
      <form ref="form">
        <input
          id="files"
          type="file"
          name="file"
          ref="uploadInput"
          accept=".jpg, .jpeg, .png"
          :multiple="false"
          @change="detectFiles($event)"
        />
      </form>
      <transition name="fade" mode="out-in">
        <v-progress-circular
          v-if="uploading"
          :size="100"
          :width="15"
          :rotate="360"
          :value="progressUpload"
          color="primary"
        >
          {{ progressUpload }}%
        </v-progress-circular>
      </transition>
    </div>
    <div v-if="uploadEnd" class="d-flex justify-center"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { db, storage } from "@/plugins/db";
export default {
  computed: {
    ...mapState("auth", ["user"])
  },
  data() {
    return {
      progressUpload: 0,
      fileName: "",
      uploadTask: "",
      uploading: false,
      uploadEnd: false,
      downloadURL: ""
    };
  },
  mounted() {},
  methods: {
    selectFile() {
      this.$refs.uploadInput.click();
    },
    detectFiles(e) {
      let fileList = e.target.files || e.dataTransfer.files;
      Array.from(Array(fileList.length).keys()).map(x => {
        this.upload(fileList[x]);
      });
    },
    upload(file) {
      this.fileName = file.name;
      this.uploading = true;
      this.uploadTask = storage
        .ref(this.user.id + "/" + this.fileName)
        .put(file);
    },
    deleteImage() {
      storage
        .ref(this.user.id + "/" + this.fileName)
        .delete()
        .then(() => {
          this.uploading = false;
          this.uploadEnd = false;
          this.downloadURL = "";
        });

      this.$refs.form.reset();
    }
  },
  watch: {
    uploadTask: function() {
      let dis = this;
      this.uploadTask.on(
        "state_changed",
        sp => {
          this.progressUpload = Math.floor(
            (sp.bytesTransferred / sp.totalBytes) * 100
          );
        },
        null,
        () => {
          this.uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
            dis.uploadEnd = true;
            dis.uploading = false;
            dis.downloadURL = downloadURL;
            db.collection("users")
              .doc(dis.user.id)
              .update({ avatar: this.downloadURL });
          });
        }
      );
    }
  }
};
</script>

<style>
.progress-bar {
  margin: 10px 0;
}
input[type="file"] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
}
</style>
